import React, { Component } from 'react';
import Slider from './Slider';
import Dropdown from './Dropdown';
import Calendar from './Calendar';
import Spinner from './Spinner';

const personsOptions = [
    { value: '1', label: '1' },
    { value: '2', label: '2' },
    { value: '3', label: '3' },
    { value: '4', label: '4' }
]; 

const reasonOptions = [
    { value: '1', label: 'Business' },
    { value: '2', label: 'Private' }
]; 

const sliderProperties = {
    autoplay: true,
    duration: 5000,
    transitionDuration: 500,
    infinite: true,
    indicators: false,
    arrows: true
}

class ShowRoom extends Component {

    constructor(){
        super()

        this.backToSearch = this.backToSearch.bind(this);
    }

    backToSearch(){
        this.props.onBackToSearch();
    }

    render(){
        return(
            <div className="vb-catalog-1 room">
                <div className="vb-pfoto">
                    <div className="react-slideshow-container">
                        {this.props.room.object.photos.length > 0 ?
                        <Slider properties={sliderProperties} images={this.props.room.object.photos} slideHeight="650px" slideWidth="522px"/>
                        : ""}                               
                    </div>

                    <button className="vb-back-to-search" onClick={this.backToSearch}>
                        <svg width="5" height="8" viewBox="0 0 5 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4.10986 0.890503L1.00024 3.99988L4.10986 7.1095" stroke="white"/>
                        </svg>										
                        Back to search
                    </button>

                    <div className="vb-table vb-upper-layer">
                        <div className="vb-td">
                            <div className="vb-phb-box">
                                {this.props.promocode ?
                                <div className="vd-phb-discount">
                                    <p>Discount:</p>
                                    <span>{this.props.room.object.promodiscount}kr</span>
                                </div>
                                : ''}
                                <div className="vb-phb-ta">
                                    <div className="vd-phb-total">
                                        <p>Total:</p>
                                        <span>2439.90kr</span>
                                    </div>

                                    <div className="vd-phb-buttons">
                                        <button className="vd-phb-addtocart">add to cart</button>
                                        <button className="vd-phb-booknow">Book now</button>
                                    </div>
                                </div>
                                <div className="vd-phb-calendar">
                                    <Calendar value={this.props.dateInterval} onSelect={this.handleIntervalselection}/>
                                </div>

                                <div className="vd-phb-select">
                                    <div className="vb-phb-select">
                                        <Dropdown
                                                value={this.props.numPersons}
                                                options={personsOptions}
                                                onChange={this.handlePersonsSelection}
                                                placeholder="1"
                                                className='vb-select-rooms'
                                                name="persons"
                                        />
                                    </div>
                                    <div className="vb-phb-select">
                                        <Dropdown
                                                value={this.props.searchReason}
                                                options={reasonOptions}
                                                onChange={this.handleReasonSelection}
                                                placeholder="choose"
                                                className='vb-select-rooms'
                                                name="reason"
                                        />
                                    </div>
                                    <div className="vb-phb-input">
                                        <input type="text" defaultValue={this.props.promocode} placeholder="enter code"/>
                                        <input type="submit" readOnly value=""/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>

                <div className="vb-content">
                    <h2>{this.props.room.object.name}</h2>
                    <div className="vb-catalog-span">
                        {this.props.room.object.mostpopular ? <span>Most popular room</span> : ''}&nbsp;
                        {(this.props.room.object.recommendedforbiz && this.props.searchReason === '1') ? <span>Reccommended For business</span> : ''}
                    </div>
                    <p>All our rates include service & taxes{this.props.room.object.breakfast ? ', Scandinavian breakfast' : ''}{this.props.room.object.wifi ? ', free WiFi' : ''}</p>
                    <div className="vb-size">Roomsize: <span>{this.props.room.object.roomsize} m<sup>2</sup></span></div>
                    <div className="vb-size">Bedsize: <span>{this.props.room.object.numbeds} {this.props.room.object.bedsize} bed{this.props.room.object.numbeds > 1 ? 's': ''}</span></div>
                    <div className="vb-order-open">
                        <div className="vb-content">
                            
                            <h2>Additionals</h2>
                            <div className="vb-additionals-box">
                                <div className="vb-checkbox">
                                    <div><input type="checkbox" onChange={this.checkBreakfast}/></div>
                                    <p>Breakfast included ({this.props.room.object.breakfastprice}kr)</p>
                                    <Spinner value="1" onChange={this.addBrekfast}/>
                                </div>
                                <div className="vb-checkbox">
                                    <div><input type="checkbox" onChange={this.checkDinner}/></div>
                                    <p>Dinner included ({this.props.room.object.dinnerprice}kr)</p>
                                    <Spinner value="1" onChange={this.addDinner}/>
                                </div>
                                <div className="vb-checkbox">
                                    <div><input type="checkbox" onChange={this.checkEarlyCheckIn} value="1"/></div>
                                    <p>Early check-in (to 11:00 am) ({this.props.room.object.earlycheckin}kr)</p>                                        
                                </div>
                                <div className="vb-checkbox">
                                    <div><input type="checkbox" onChange={this.checkLateCheckOut} value="1"/></div>
                                    <p>Late check-out (after 14:00 pm) ({this.props.room.object.latecheckout}kr)</p>                                        
                                </div>
                            </div>


                            <div className="clearfix"></div>
                            <h2>Room includes</h2>
                            <div className="vb-roomincludes-box">

                                { (this.props.room.object.bedsize === 'double' || this.props.room.object.bedsize === 'kingsize') ? 
                                <p>
                                        <svg width="15" height="12" viewBox="0 0 15 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M14.8249 8.01653L13.1897 5.42777V0.66561L12.5241 0H2.33055L1.66494 0.66561V5.42773L0.0297852 8.01653H14.8249ZM11.8585 1.33122V4.65402C11.0007 4.43213 9.51884 4.1585 7.42734 4.1585C5.33584 4.1585 3.85396 4.43213 2.99616 4.65402V1.33122H11.8585Z" fill="#E0E0E0"/>
                                            <path d="M0 8.83557V10.1668H1.55099V12H2.88221V10.1668H11.9725V12H13.3038V10.1668H14.8548V8.83557H0Z" fill="#E0E0E0"/>
                                            <path d="M6.88725 3.46588V2.69038C6.88725 2.23009 6.21921 1.85681 5.39515 1.85681C4.57108 1.85681 3.90308 2.23009 3.90308 2.69038V3.8544C3.90308 3.8544 4.7832 3.63281 5.38815 3.57553C5.93277 3.52392 6.88725 3.46588 6.88725 3.46588Z" fill="#E0E0E0"/>
                                            <path d="M10.9517 3.8544V2.69038C10.9517 2.23009 10.2837 1.85681 9.45964 1.85681C8.63557 1.85681 7.96753 2.23009 7.96753 2.69038V3.46588C7.96753 3.46588 8.92205 3.52388 9.46667 3.57553C10.0717 3.63281 10.9517 3.8544 10.9517 3.8544Z" fill="#E0E0E0"/>
                                        </svg>		
                                        Double bed
                                </p>
                                    : ''}
                                    
                                {this.props.room.object.wifi ? 
                                <p>
                                        <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M2.56693 5.51409C2.23778 5.84503 2.23778 6.38363 2.56693 6.71782C2.89608 7.04876 3.43175 7.04876 3.76413 6.71782C6.04236 4.42716 9.75012 4.42716 12.0284 6.71782C12.1929 6.88329 12.4091 6.96765 12.6253 6.96765C12.8415 6.96765 13.0577 6.88329 13.2223 6.71782C13.5515 6.38687 13.5515 5.84828 13.2223 5.51409C10.2858 2.55829 5.50346 2.55829 2.56693 5.51409Z" fill="#E0E0E0"/>
                                            <path d="M4.8516 7.81124C4.52245 8.14218 4.52245 8.68078 4.8516 9.01497C5.18075 9.34591 5.71642 9.34591 6.0488 9.01497C7.06529 7.98969 8.72394 7.98969 9.74043 9.01497C9.905 9.18044 10.1212 9.2648 10.3374 9.2648C10.5536 9.2648 10.7698 9.18044 10.9344 9.01497C11.2636 8.68402 11.2636 8.14543 10.9344 7.81448C9.25961 6.12407 6.52961 6.12407 4.8516 7.81124Z" fill="#E0E0E0"/>
                                            <path d="M7.89476 12.0001C8.51675 12.0001 9.02097 11.4931 9.02097 10.8677C9.02097 10.2423 8.51675 9.73535 7.89476 9.73535C7.27277 9.73535 6.76855 10.2423 6.76855 10.8677C6.76855 11.4931 7.27277 12.0001 7.89476 12.0001Z" fill="#E0E0E0"/>
                                            <path d="M15.5426 3.17805C11.325 -1.05935 4.46449 -1.05935 0.246862 3.17805C-0.0822873 3.50899 -0.0822873 4.04759 0.246862 4.38178C0.576011 4.71272 1.11168 4.71272 1.44406 4.38178C5.00016 0.803028 10.7893 0.803028 14.3486 4.38178C14.5132 4.54725 14.7294 4.63161 14.9456 4.63161C15.1618 4.63161 15.378 4.54725 15.5426 4.38178C15.8718 4.05083 15.8718 3.51223 15.5426 3.17805Z" fill="#E0E0E0"/>
                                        </svg>									
                                        Wi-Fi
                                </p>    
                                : ''}
                                    
                                {this.props.room.object.hairdryier ? 
                                <p>
                                        <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M13.4626 0.982015C11.7496 0.327348 10.3251 0 9.18922 0C8.7051 0 8.14648 0.0701439 7.51338 0.210432C6.88027 0.350719 6.35891 0.495693 5.94925 0.645324L5.36271 0.841727C5.17649 0.916893 4.99031 0.963665 4.80409 0.982015L0.279308 1.45899C0.0930932 1.49639 0 1.60862 0 1.79568V4.18058C0 4.36764 0.0930932 4.47987 0.279308 4.51727L4.80409 5.24676C4.99031 5.28416 5.17649 5.34028 5.36271 5.41511L8.43509 6.20072C8.63991 6.23815 8.77026 6.34101 8.82612 6.50935L10.6416 11.7842C10.6975 11.9712 10.8185 12.0367 11.0047 11.9806L12.9319 11.3353C13.1182 11.2605 13.174 11.1389 13.0995 10.9705L11.8426 7.29497C11.7868 7.12662 11.7589 7.03313 11.7589 7.01439C11.703 6.78993 11.6797 6.61693 11.689 6.49532C11.6987 6.37378 11.722 6.27558 11.7589 6.20072L11.7868 6.11658C11.9171 5.96695 12.0754 5.86406 12.2616 5.80794L13.4906 5.30291C13.6581 5.20939 13.7419 5.0691 13.7419 4.88204V1.37482C13.7419 1.18776 13.6488 1.05684 13.4626 0.982015ZM10.5159 3.84389C10.2646 4.08706 9.96198 4.20863 9.60818 4.20863C9.25438 4.20863 8.94715 4.08706 8.68647 3.84389C8.42579 3.60071 8.29544 3.30145 8.29544 2.94604C8.29544 2.59064 8.42579 2.28669 8.68647 2.03417C8.94715 1.78165 9.25438 1.6554 9.60818 1.6554C9.96198 1.6554 10.2646 1.78165 10.5159 2.03417C10.7673 2.28669 10.893 2.59064 10.893 2.94604C10.893 3.30148 10.7673 3.60077 10.5159 3.84389Z" fill="#E0E0E0"/>
                                        </svg>									
                                        Hair Dryer
                                </p>
                                    : ''}
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default ShowRoom;